import React, { useState } from 'react';
import PublicNav from './PublicNav';
import ProductInquiryService from './ProductInquiryService';

const C = {
  ink: '#344767',
  muted: '#8392ab',
  border: '#e9ecef',
  primary: '#5e72e4',
  success: '#2dce89',
  bgSoft: '#f8f9fe',
  shadow: '0 2px 24px rgba(52,71,103,0.09)',
};

const inp = {
  width: '100%',
  padding: '11px 14px',
  border: `1.5px solid ${C.border}`,
  borderRadius: 10,
  fontSize: 14,
  color: C.ink,
  boxSizing: 'border-box',
  outline: 'none',
};

export default function ProductContact() {
  const [form, setForm] = useState({
    fullName: '',
    email: '',
    phone: '',
    company: '',
    subject: '',
    message: '',
  });
  const [sending, setSending] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState(null);

  const onChange = (e) => setForm((p) => ({ ...p, [e.target.name]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    setError(null);
    try {
      await ProductInquiryService.sendProductInquiry({
        fullName: form.fullName.trim(),
        email: form.email.trim(),
        phone: form.phone.trim() || null,
        company: form.company.trim() || null,
        subject: form.subject.trim() || null,
        message: form.message.trim(),
      });
      setDone(true);
      setForm({ fullName: '', email: '', phone: '', company: '', subject: '', message: '' });
    } catch (err) {
      const msg = err.response?.data?.error || 'Something went wrong. Please try again.';
      setError(msg);
    } finally {
      setSending(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: C.bgSoft, fontFamily: 'inherit' }}>
      <PublicNav />

      <div style={{ background: 'linear-gradient(135deg,#344767 0%,#21243d 100%)', padding: '44px 24px 56px', textAlign: 'center' }}>
        <h1 style={{ margin: 0, fontSize: 30, fontWeight: 800, color: '#fff' }}>Contact sales</h1>
        <p style={{ margin: '12px auto 0', maxWidth: 480, color: 'rgba(255,255,255,0.72)', fontSize: 15 }}>
          Tell us about your agency or project — we&apos;ll follow up with pricing and onboarding options.
        </p>
      </div>

      <div style={{ maxWidth: 560, margin: '0 auto', padding: '40px 20px 60px' }}>
        <div style={{ background: '#fff', borderRadius: 16, padding: 28, boxShadow: C.shadow, border: `1px solid ${C.border}` }}>
          {done ? (
            <div style={{ textAlign: 'center', padding: '16px 0' }}>
              <div style={{ fontSize: 42, color: C.success, marginBottom: 12 }}>
                <i className="fas fa-check-circle" aria-hidden />
              </div>
              <p style={{ margin: 0, fontWeight: 700, color: C.ink }}>Thanks — your message was sent.</p>
              <p style={{ margin: '10px 0 0', color: C.muted, fontSize: 14 }}>Our team will reply shortly.</p>
              <button
                type="button"
                onClick={() => setDone(false)}
                style={{
                  marginTop: 20,
                  padding: '10px 20px',
                  borderRadius: 10,
                  border: `1px solid ${C.border}`,
                  background: '#fff',
                  fontWeight: 600,
                  cursor: 'pointer',
                  color: C.ink,
                }}
              >
                Send another message
              </button>
            </div>
          ) : (
            <form onSubmit={submit}>
              <label style={{ display: 'block', marginBottom: 14 }}>
                <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: C.muted, marginBottom: 6 }}>Full name *</span>
                <input name="fullName" value={form.fullName} onChange={onChange} required style={inp} />
              </label>
              <label style={{ display: 'block', marginBottom: 14 }}>
                <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: C.muted, marginBottom: 6 }}>Work email *</span>
                <input name="email" type="email" value={form.email} onChange={onChange} required style={inp} />
              </label>
              <label style={{ display: 'block', marginBottom: 14 }}>
                <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: C.muted, marginBottom: 6 }}>Phone</span>
                <input name="phone" type="tel" value={form.phone} onChange={onChange} style={inp} />
              </label>
              <label style={{ display: 'block', marginBottom: 14 }}>
                <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: C.muted, marginBottom: 6 }}>Company / agency</span>
                <input name="company" value={form.company} onChange={onChange} style={inp} />
              </label>
              <label style={{ display: 'block', marginBottom: 14 }}>
                <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: C.muted, marginBottom: 6 }}>Subject</span>
                <input name="subject" value={form.subject} onChange={onChange} placeholder="e.g. Demo for 20-seat agency" style={inp} />
              </label>
              <label style={{ display: 'block', marginBottom: 18 }}>
                <span style={{ display: 'block', fontSize: 12, fontWeight: 700, color: C.muted, marginBottom: 6 }}>How can we help? *</span>
                <textarea
                  name="message"
                  value={form.message}
                  onChange={onChange}
                  required
                  rows={5}
                  style={{ ...inp, resize: 'vertical', minHeight: 120 }}
                />
              </label>
              {error && (
                <p style={{ color: '#f5365c', fontSize: 13, margin: '0 0 14px' }}>
                  <i className="fas fa-exclamation-circle" style={{ marginRight: 6 }} />
                  {error}
                </p>
              )}
              <button
                type="submit"
                disabled={sending}
                style={{
                  width: '100%',
                  padding: '14px',
                  borderRadius: 12,
                  border: 'none',
                  background: C.primary,
                  color: '#fff',
                  fontWeight: 800,
                  fontSize: 15,
                  cursor: sending ? 'wait' : 'pointer',
                }}
              >
                {sending ? 'Sending…' : 'Send message'}
              </button>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
